import keys from '@debbie/common/dist/cache/keys.js';
import { DocumentTypes } from '@debbie/common/dist/documents/index.js';
import { Entity } from '@debbie/common/dist/index.js';
import * as documentsAPI from '@debbie/cortex/dist/api/documents.js';
import * as filesAPI from '@debbie/cortex/dist/api/files.js';
import { selectAuthToken } from '@debbie/cortex/dist/auth/selectors.js';
import { useFee, useParkingLotFiles, } from '@debbie/cortex/dist/bespoke/apcoa/index.js';
import { documentsEntity } from '@debbie/cortex/dist/documents/index.js';
import { notifications } from '@debbie/cortex/dist/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useNewInteraction } from '@debbie/cortex/dist/newInteractions/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTenantId } from '@debbie/cortex/dist/tenant/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { APIBASE } from '../../../config.js';
import Button from '../../Button.js';
import Errors from '../../Errors.js';
import File from '../../File/index.js';
import PlaceholderLoader from '../../PlaceholderLoader.js';
import PowerTable from '../../PowerTable.js';
const getFileBase64 = async (authToken, url) => {
    const file = await fetch(url, {
        headers: {
            Authorization: `Bearer ${authToken}`,
        },
    })
        .then((response) => response.blob())
        .then((blob) => new Promise((resolve) => {
        let reader = new FileReader();
        reader.onload = function () {
            const dataUrl = this.result;
            resolve({
                content: dataUrl.split(',')[1],
            });
        };
        reader.readAsDataURL(blob);
    }));
    return file;
};
const ParkingLotFiles = (props) => {
    const { caseVoucher } = props;
    const tenantId = useTenantId();
    const authToken = useSelector(selectAuthToken);
    const feeLoadable = useFee(caseVoucher.referenceId);
    const fee = h.isLoaded(feeLoadable) ? feeLoadable.data : null;
    const filesLoadable = useParkingLotFiles(fee?.parkingLotCode);
    const files = h.hasData(filesLoadable) ? filesLoadable.data : null;
    const error = h.isError(filesLoadable) ? filesLoadable.error : null;
    const [interaction, setInteraction] = useNewInteraction(props.caseVoucher.caseId);
    const uploadedFiles = interaction.uploadedFiles;
    const [loadingAddToInteraction, setLoadingAddToInteraction] = useState(null);
    const [loadingAddToDocumentation, setLoadingAddToDocumentation] = useState(null);
    const [added, setAdded] = useState(false);
    const addToDocuments = async (fileURL, fileName, contentType) => {
        try {
            setLoadingAddToDocumentation(fileName);
            if (!props.caseVoucher.caseId) {
                throw new Error('No caseId');
            }
            const file = await getFileBase64(authToken, fileURL);
            const newFile = await filesAPI.save({
                content: file.content,
                name: fileName,
                contentType: contentType,
            });
            await documentsAPI.add(props.caseVoucher.caseId, DocumentTypes.OTHER, Entity.Case, newFile.file, false, undefined, undefined, 'debtor');
            q.invalidate(keys.write.create(documentsEntity));
            notifications.notification({
                title: 'Billedet er tilføjet til dokumentation',
            });
            setAdded(true);
        }
        catch (error) {
            console.error(error);
            alert('Error');
        }
        setLoadingAddToDocumentation(null);
    };
    const addToNewInteraction = async (fileURL, fileName, contentType) => {
        try {
            setLoadingAddToInteraction(fileName);
            if (!props.caseVoucher.caseId) {
                throw new Error('No caseId');
            }
            const file = await getFileBase64(authToken, fileURL);
            const newFile = await filesAPI.save({
                content: file.content,
                name: fileName,
                contentType: contentType,
            });
            setInteraction('uploadedFiles', [...uploadedFiles, newFile.file]);
            notifications.notification({
                title: 'Billedet er tilføjet til interaktioner',
            });
            setAdded(true);
        }
        catch (error) {
            console.error(error);
            alert('Error');
        }
        setLoadingAddToInteraction(null);
    };
    if (h.isLoading(filesLoadable)) {
        return React.createElement(PlaceholderLoader, null);
    }
    if (error) {
        return React.createElement(Errors, { errors: [error.message] });
    }
    return (React.createElement(React.Fragment, null, files ? (React.createElement(Wrapper, null, React.createElement(PowerTable, { data: files.map((file) => {
            file.url = `${APIBASE}/v1/${tenantId}/apcoa/parkinglot/${fee?.parkingLotCode}/files/actual?path=${encodeURIComponent(file.fullPathFilename)}&filename=${encodeURIComponent(file.filename)}`;
            return file;
        }), genKey: (file) => `${file.ID}`, pagination: {
            type: 'none',
            pageSize: files.length,
        }, values: {
            filename: {
                label: 'Filnavn',
                toCmp: (filename) => filename,
                map: (filename, file) => {
                    return (React.createElement("div", { style: {
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        } },
                        React.createElement("b", null, filename),
                        ' ',
                        React.createElement("div", { style: { float: 'right' } },
                            React.createElement(File, { file: {
                                    url: file.url,
                                    fileName: filename,
                                    contentType: file.contentType,
                                }, download: true, style: { marginBottom: '0px' } }),
                            React.createElement(Button, { size: "mini", theme: "secondary", loading: loadingAddToDocumentation === file.filename, onClick: () => {
                                    addToDocuments(file.url, file.filename, file.contentType);
                                }, style: { marginRight: '5px' } }, "Tilf\u00F8j til dokumentation"),
                            React.createElement(Button, { size: "mini", theme: "secondary", loading: loadingAddToInteraction === file.filename, onClick: () => {
                                    addToNewInteraction(file.url, file.filename, file.contentType);
                                } }, "Tilf\u00F8j til interaktion (email, note...)"))));
                },
            },
        }, defaultSortKey: "filename", defaultSortDirection: "ASC", searchable: true, toSearchStr: (file) => `${file.filename} ${file.fullPathFilename}` }))) : (React.createElement(PlaceholderLoader, null))));
};
export default ParkingLotFiles;
const Wrapper = styled.div `
  td {
    padding: 0.5em;
  }
`;
//# sourceMappingURL=ParkingLotFiles.js.map